@if (shown) {
  <div class="loading">
    <div class="loadingContainer">
      <div class="loadingItem">
        <img src="assets/images/AntemetA1.png" alt="" class="scale-in-center">
        <br />
        {{ text }}
      </div>
    </div>
  </div>
}
